import { MultiProgress, Progress } from '@procurify/ui'

export interface BudgetBreakdownBar {
  progressValue: number
  label: string
  color: string
  striped?: boolean
}
export interface IBudgetCategoryCardBudgetBreakdownProps {
  bars: BudgetBreakdownBar[]
}

export const BudgetCategoryCardBudgetBreakdown = ({
  bars,
}: IBudgetCategoryCardBudgetBreakdownProps) => {
  return (
    <MultiProgress>
      {bars.map((bar) => {
        if (!bar.progressValue) return

        return (
          <Progress
            value={bar.progressValue}
            label={bar.label}
            color={bar.color}
            striped={!!bar.striped}
            key={bar.label}
          />
        )
      })}
    </MultiProgress>
  )
}

BudgetCategoryCardBudgetBreakdown.displayName =
  'BudgetCategoryCardBudgetBreakdown'
